import './App.scss';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { AuthProvider } from "./context/authContext";

import Login from "./components/Login/Login";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter future={{ v7_startTransition: true }}>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            {/* Rutas privadas */}
            <Route element={<PrivateRoute/>}>
              <Route exact path="/dashboard" element={<Dashboard />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
    );
}

export default App;
